import script from "./GroupPurchaseCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupPurchaseCreate.vue?vue&type=script&setup=true&lang=js"

import "./GroupPurchaseCreate.vue?vue&type=style&index=0&id=3a756e6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a756e6a"]])

export default __exports__